import { render, staticRenderFns } from "./DataCustomer.vue?vue&type=template&id=045db54b&"
import script from "./DataCustomer.vue?vue&type=script&lang=js&"
export * from "./DataCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DataCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports